/**
 * PRISM 로고타입 (텍스트). 이미지 대신 Black(900) 두께의 시스템 산세리프 "PRISM" + 얇은 세로선 + 한국어 명칭을 한 줄로, 세로 중앙.
 * 색은 currentColor 를 따라 헤더 색(CR-026)에 맞춰진다.  md: 앱 헤더·서비스 사이트  lg: 로그인 셸
 */
export const PRODUCT_KO = '개인정보 및 정보보안관리체계';
export function Logotype({ size = 'md', className = '' }: { size?: 'md' | 'lg'; className?: string }) {
  return (
    <span className={`logotype logotype-${size} ${className}`} role="img" aria-label={`PRISM ${PRODUCT_KO}`}>
      <span className="logotype-mark" aria-hidden>PRISM</span>
      <span className="logotype-sep" aria-hidden />
      <span className="logotype-ko" aria-hidden>{PRODUCT_KO}</span>
    </span>
  );
}
